import React from 'react';

import Checkbox from 'components/DesignSystem/Checkbox';
import useNumericForecastCP from 'utils/hooks/meteorology/useNumericForecastControlPanel';

export default function ModelCheckbox({ value, label }: { value: string, label: string }) {
  const { toggleModel, models } = useNumericForecastCP();
  const checked = models.includes(value);

  return (
    <Checkbox
      id={`model-checkbox-${value}`}
      className="text-uppercase pe-1"
      label={label}
      onChange={() => toggleModel(value)}
      checked={checked}
    />
  );
}
